import React, { useEffect, useRef, useState } from 'react';

function Hamburger() {
    const [isActive, setIsActive] = useState(false);

    const toggleOverlay = () => {
        setIsActive(!isActive);
    };

    return (
        <div className="header-right">
            <div onClick={toggleOverlay}>
                <svg width="28" height="10" viewBox="0 0 28 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Group 14">
                    <line id="Line 1" y1="0.5" x2="28" y2="0.5" stroke="#737373"/>
                    <line id="Line 2" y1="9.5" x2="14" y2="9.5" stroke="#737373"/>
                    </g>
                </svg>
            </div>
            <div className={`hamburger-overlay ${isActive ? 'on' : 'off'}`}>
                <img className='hamburger-close' src={`${process.env.PUBLIC_URL}/images/cross.png`} onClick={toggleOverlay}>
                </img>
                <p className='hamburger-address'>
                    United States of America<br></br>
                    New York<br></br>
                    NY
                </p>
                <a href="https://www.linkedin.com/in/jekuper/" target="_blank">
                    <div className="img-container">
                        <img src={`${process.env.PUBLIC_URL}/images/page1/linkedIn.png`}>
                        </img>
                    </div>
                </a>
                <a className='email-button' href="mailto:joesharipov@gmail.com" target="_blank">
                    <div className="img-container">
                        <img src={`${process.env.PUBLIC_URL}/images/page1/emailRound.png`}>
                        </img>
                    </div>
                </a>
                <a href="https://github.com/jekuper" target="_blank">
                    <div className="img-container">
                        <img src={`${process.env.PUBLIC_URL}/images/page1/github.png`}>
                        </img>
                    </div>
                </a>
                <a href="https://jekuper.itch.io/" target="_blank">
                    <div className="img-container">
                        <img src={`${process.env.PUBLIC_URL}/images/page1/itchio.png`}>
                        </img>
                    </div>
                </a>
            </div>
        </div>
    );
}

export default Hamburger;
